mutation SetClickNotification($input: ClickNotificationSetInput!) {
    clickNotificationSet(input: $input) {
        link {
            link
        }
    }
}
